<template>
    <div class="pb-1 flex flex-col items-start gap-2" data-testid="sms-ai-action-row">
        <button
            class="sms-ai-action-button inline-flex h-[34px] items-center justify-center gap-[8px] rounded-[4px] px-[10px] py-[2px] text-[14px] font-normal shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
            data-testid="sms-ai-generate-button"
            type="button"
            :disabled="generateDisabled"
            @click="generateDraft"
            v-if="showGenerateButton"
        >
            <icon data-testid="sms-ai-generate-icon" name="regular/ai-edit-spark" />
            <span data-testid="sms-ai-generate-label">
                {{ $t('smsCommunication.aiDraft.generateDraft') }}
            </span>
        </button>

        <span
            class="text-sm text-gray-400"
            data-testid="sms-ai-service-lead-helper"
            v-if="showGenerateServiceLeadHelper"
        >
            {{ $t('smsCommunication.aiDraft.serviceLeadUnavailable') }}
        </span>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        generateDisabled: boolean;
        showGenerateButton: boolean;
        showGenerateServiceLeadHelper: boolean;
    }>();

    const emit = defineEmits<{
        generate: [];
    }>();

    const generateDraft = () => {
        emit('generate');
    };
</script>

<style scoped>
    .sms-ai-action-button {
        position: relative;
        color: #0038ff;
        border: 1px solid transparent;
        background: #fff;
    }

    .sms-ai-action-button::before {
        position: absolute;
        inset: -1px;
        content: '';
        pointer-events: none;
        border-radius: inherit;
        background: linear-gradient(105deg, #0038ff 0%, #0038ff 45%, #ff2d55 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask-composite: exclude;
        padding: 1px;
    }
</style>
